/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Import_Failed_GenericInputs */

const en_ui_import_failed_generic = /** @type {(inputs: Ui_Import_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong while importing. Try again.`)
};

const de_ui_import_failed_generic = /** @type {(inputs: Ui_Import_Failed_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Importieren ist etwas schiefgelaufen. Versuch es noch einmal.`)
};

/**
* | output |
* | --- |
* | "Something went wrong while importing. Try again." |
*
* @param {Ui_Import_Failed_GenericInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_failed_generic = /** @type {((inputs?: Ui_Import_Failed_GenericInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Failed_GenericInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_failed_generic(inputs)
	return de_ui_import_failed_generic(inputs)
});